import app from '../app';
import blogArticles from './blog/blog-articles';

app.add({
  blogArticles,
});
app.mount();
